/**
 * Toast — schwebende Benachrichtigungen.
 * Auto-Dismiss nach 3s, Stacking bei mehreren.
 */
import { el } from '../../utils/domHelpers.js';

const TOAST_DURATION = 3000;

export const toast = {

  show(message, type = 'info') {
    const container = document.getElementById('toast-container');
    if (!container) return;

    const node = el('div', { class: `toast toast--${type} mono` }, [message]);
    container.appendChild(node);

    // Auto-Remove mit Fade-Out
    setTimeout(() => {
      node.style.opacity = '0';
      node.style.transform = 'translateX(40px)';
      setTimeout(() => node.remove(), 300);
    }, TOAST_DURATION);
  },

  success(msg) { this.show(msg, 'success'); },
  error(msg)   { this.show(msg, 'error'); },
  info(msg)    { this.show(msg, 'info'); },
};
